<div class="tw-flex tw-flex-col tw-gap-3">
  <!-- Intro -->
  <p class="tw-text-sm tw-text-dt-text-secondary tw-px-1">
    {{ "selectTransactionToLink" | i18n }}
  </p>

  <!-- Search -->
  <input
    type="text"
    [value]="search()"
    (input)="updateSearch($any($event.target).value)"
    [placeholder]="'searchTransactions' | i18n"
    class="tw-w-full tw-rounded-lg tw-bg-dt-surface-card tw-px-4 tw-py-2.5 tw-text-base tw-text-dt-text-headings tw-shadow-neuomorphic-inset tw-border-none focus:tw-outline-none"
  />

  <!-- Candidates -->
  @if (candidates().length) {
    <div class="tw-flex tw-flex-col tw-gap-2">
      @for (candidate of candidates(); track candidate.transaction.id) {
        <div
          class="tw-rounded-xl tw-bg-dt-surface-card tw-shadow-card-elevated tw-p-4 tw-flex tw-items-center tw-justify-between tw-gap-3"
        >
          <div class="tw-flex tw-flex-col tw-gap-1 tw-min-w-0">
            <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
              <span
                class="tw-text-base tw-font-medium tw-text-dt-text-headings tw-truncate"
                [title]="candidate.description"
                >{{ candidate.description }}</span
              >
              <app-link-type-badge [type]="candidate.linkType"></app-link-type-badge>
            </div>
            <div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-dt-text-secondary">
              <span
                [ngClass]="
                  candidate.direction === TransactionDirection.In
                    ? 'tw-text-dt-text-in-primary'
                    : 'tw-text-dt-text-out-primary'
                "
                style="font-variant-numeric: tabular-nums"
              >
                {{ candidate.direction !== TransactionDirection.In ? "-" : ""
                }}{{ candidate.amount | number: "1.2-2" }} {{ candidate.symbol }}
              </span>
              <span>·</span>
              <span>{{ candidate.date | date: "d MMM yyyy" }}</span>
              @if (candidate.account) {
                <span>·</span>
                <span class="tw-truncate">{{ candidate.account }}</span>
              }
            </div>
          </div>
          <button
            (click)="link(candidate)"
            [disabled]="linking()"
            class="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5 tw-text-dt-text-action tw-font-bold disabled:tw-opacity-50 disabled:tw-cursor-default"
          >
            <icon [name]="'link'" [size]="4" class="tw-text-dt-text-action"></icon>
            <span class="tw-cursor-pointer">{{ "link" | i18n }}</span>
          </button>
        </div>
      }
    </div>
  } @else {
    <div class="tw-rounded-xl tw-bg-dt-surface-card tw-shadow-card-elevated tw-p-8 tw-text-center">
      <span class="tw-text-base tw-text-dt-text-secondary">{{
        "noLinkableTransactions" | i18n
      }}</span>
    </div>
  }
</div>
